(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(() => {
function init(header){
if(header.dataset.ready)return;header.dataset.ready='true';
const root=header.querySelector('.vm-root'),groups=[...header.querySelectorAll('.vm-group')],desktop=matchMedia('(min-width:1000px)'),hover=matchMedia('(hover:hover) and (pointer:fine)');
let timer;
const close=()=>groups.forEach(g=>g.open=false);
const resize=()=>{close();root.open=desktop.matches;};
resize();desktop.addEventListener('change',resize);
groups.forEach(g=>{
g.querySelector('summary').addEventListener('click',e=>{clearTimeout(timer);groups.filter(x=>x!==g).forEach(x=>x.open=false);if(desktop.matches&&hover.matches){e.preventDefault();g.open=true;}});
g.addEventListener('pointerenter',()=>{if(desktop.matches&&hover.matches){clearTimeout(timer);groups.filter(x=>x!==g).forEach(x=>x.open=false);g.open=true;}});
g.addEventListener('pointerleave',()=>{if(desktop.matches&&hover.matches)timer=setTimeout(()=>{if(!g.contains(document.activeElement))g.open=false;},180);});
g.querySelector('.vm-close').addEventListener('click',()=>{g.open=false;g.querySelector('summary').focus();});
});
header.addEventListener('keydown',e=>{if(e.key==='Escape'){const active=groups.find(g=>g.open);close();if(active)active.querySelector('summary').focus();else if(!desktop.matches){root.open=false;root.querySelector('summary').focus();}}});
header.addEventListener('focusout',()=>setTimeout(()=>{if(!header.contains(document.activeElement)){close();if(!desktop.matches)root.open=false;}},0));
document.addEventListener('click',e=>{if(!header.contains(e.target)){close();if(!desktop.matches)root.open=false;}});
}
document.querySelectorAll('[data-veloura-mega]').forEach(init);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-veloura-mega]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();
})();
